import { cartLineNotesStyles } from "@insite/content-library/Widgets/Cart/CartLineNotes";
import { editLinkStyles } from "@store/theme/common/mixins";
import { css } from "styled-components";

Object.assign(cartLineNotesStyles, {
    toggleLink: {
        css: css`
            ${editLinkStyles()}
        `,
    },
    editableNotesTextArea: {
        sizeVariant: "small",
        cssOverrides: {
            formField: css`
                margin-top: 0.25em;
            `,
        },
    },
});
